import { current } from "@reduxjs/toolkit"
import { setReponsesList,setIsGameChallengeCompleted,resetChallengeGame,setCurrentExercice } from "../../reducers/exercice_zone/challengeZone"

import { store } from "../../store/store"
import axios from "axios"
import { setNiveauProfile } from "../../reducers/niveau"
import { setTechnologyProfile } from "../../reducers/technologies"

import { PLAY_EXO_API_ROUTE,SEND_RESPONSE_EXO_API_ROUTE } from "../../../routes/api/api_routes"


const play_exo = {
    getExercice(challenge_profile_id,completed,tech_id,niveau_id){
        return new Promise((resolve,reject)=>{
            axios.post(`${PLAY_EXO_API_ROUTE}${challenge_profile_id}/${completed}/${tech_id}/${niveau_id}`,'',{
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`JWT ${localStorage.getItem('access')}`,
                    'Accept':'application/json'
                }
              })
            .then(response => {
                console.log(response);
                if(response.status === 200){
                    let dispatch = store.dispatch
                    let exercice = response.data.data.challenge_profile.exercice
                    console.log("My exercice: ",exercice)
                    let reponses = response.data.data.challenge_profile.reponses
                    dispatch(resetChallengeGame())
                    dispatch(setCurrentExercice(exercice))
                    dispatch(setReponsesList(reponses))
                    /*dispatch(setNiveauProfile(niveau))
                    dispatch(setTechnologyProfile(tech))*/
                    resolve(response.status)
                }else{
                    reject(response)
                }
            })
            .catch(err => {
                console.log(err);
                reject(err)
            })
        })
    },
    sendResponseExercice(exercice_id,challenge_profile_id,response_id,completed,code_bakelist){
        console.log("Code: ",)
        const json = JSON.stringify(code_bakelist);
        return new Promise((resolve,reject)=>{
            axios.post(`${SEND_RESPONSE_EXO_API_ROUTE}${exercice_id}/${challenge_profile_id}/${response_id}/${completed}`,json,{
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`JWT ${localStorage.getItem('access')}`,
                    'Accept':'application/json'
                },
                
              })
            .then(response => {
                let dispatch = store.dispatch
                if(response?.data?.resultat?.completed){
                    console.log(response);
                    dispatch(setIsGameChallengeCompleted(response?.data?.resultat))
                }else if(response.status === 200){
                    let exercice = response.data.data.challenge_profile.exercice
                    let reponses = response.data.data.challenge_profile.reponses

                    dispatch(setCurrentExercice(exercice))
                    dispatch(setReponsesList(reponses))
                    resolve(response.status)
                }else{
                    reject(response)
                }
            })
            .catch(err => {
                console.log(err);
                reject(err)
            })
        })
    },
}
export default play_exo